<template>
  <v-app>
    <v-container>
      <h1>Informationspflicht lt. &sect; 5 Abs. 1 E-Commerce-Gesetz</h1>
      <div class="mat-list-item-content">
        <div class="mat-list-item-ripple mat-ripple">&nbsp;</div>
        <strong>Inhaber:</strong>&nbsp;DI (FH) Thomas Schmit
      </div>
      <div class="mat-list-item-content">
        <div class="mat-list-item-ripple mat-ripple">&nbsp;</div>
        <strong>Firmenwortlaut (laut Firmenbuch):</strong>&nbsp;smartGIS e.U.. (FN 356678b)
      </div>
      <div class="mat-list-item-content">
        <div class="mat-list-item-ripple mat-ripple">&nbsp;</div>
        <strong>Firmenbuchnummer:</strong>&nbsp;356678b
      </div>
      <div class="mat-list-item-content">
        <div class="mat-list-item-ripple mat-ripple">&nbsp;</div>
        <strong>Firmengericht:</strong>&nbsp;Landesgericht Klagenfurt
      </div>
      <div class="mat-list-item-content">
        <div class="mat-list-item-ripple mat-ripple">&nbsp;</div>
        <strong>GLN (der &ouml;ffentlichen Verwaltung):</strong>&nbsp;9110017687727
      </div>
      <div class="mat-list-item-content">
        <div class="mat-list-item-ripple mat-ripple">&nbsp;</div>
        <strong>GISA-Zahl:</strong>&nbsp;10792209
      </div>
      <div class="mat-list-item-content">
        <div class="mat-list-item-ripple mat-ripple">&nbsp;</div>
        <strong>Beh&ouml;rde gem. ECG (E-Commerce Gesetz):</strong>&nbsp;Magistrat der Stadt Klagenfurt
      </div>
      <div class="mat-list-item-content">
        <div class="mat-list-item-ripple mat-ripple">&nbsp;</div>
        <strong>Vollst&auml;ndige Informationen finden Sie auf der&nbsp;<a
          href="https://firmen.wko.at/Web/DetailsKontakt.aspx?FirmaID=2ed347c4-e6d5-4e84-a9c9-ca4d83c2f828"
          target="_new">WKO-Seite</a>.</strong></div>
      <h2>Haftungsausschluss</h2>
      <p>Der Betreiber dieser Applikation &uuml;bernimmt keinerlei Gew&auml;hr f&uuml;r die Aktualit&auml;t,
        Korrektheit, Vollst&auml;ndigkeit, Qualit&auml;t oder Herkunft der Dateninhalte. Haftungsanspr&uuml;che gegen
        den Betreiber, welche sich auf Sch&auml;den materieller oder ideeller Art beziehen, die durch die Nutzung oder
        Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollst&auml;ndiger
        Informationen verursacht wurden, sind grunds&auml;tzlich ausgeschlossen.</p>
    </v-container>
  </v-app>
</template>

<script>
  export default {
    name: 'Impressum',
  };
</script>

<style scoped>

</style>
